// extracted by css-extract-rspack-plugin
var _1 = "og8oorYyV8A82AnV";
var _2 = "qs6e_OZrizUCesD8";
export { _1 as "badge", _2 as "popover" }
